import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BookOpen } from 'lucide-react';

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&family=Inter:wght@300;400;600;700&display=swap');
        .font-serif { font-family: 'Playfair Display', serif; }
        .font-sans { font-family: 'Inter', sans-serif; }
      `}</style>

      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/5 backdrop-blur-xl border-b border-white/10 py-5 px-8 md:px-16">
        <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
          <div className="w-10 h-10 bg-white flex items-center justify-center text-slate-900 font-serif text-2xl font-bold">M</div>
          <span className="text-[13px] tracking-[0.15em] font-bold text-white lowercase">
            mylookbook<span className="text-slate-400 font-light">.online</span>
          </span>
        </Link>
      </nav>

      {/* Hero Section */}
      <main className="pt-32 pb-20 px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-20">
            <h1 className="text-6xl md:text-8xl font-serif mb-8 leading-[1.1]">
              Your Digital <span className="italic">Lookbooks</span>.
            </h1>
            <p className="text-slate-300 text-xl font-light leading-relaxed max-w-2xl mx-auto">
              Explore our curated collection of property catalogs and digital showcases.
            </p>
          </div>

          {/* Lookbook Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
            {/* Lookbook Pacifico Card */}
            <Link 
              to="/lookbookpacifico"
              className="group relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg overflow-hidden hover:bg-white/10 transition-all duration-500 hover:scale-105 hover:shadow-2xl"
            >
              <div className="p-8">
                <div className="flex items-center justify-between mb-6">
                  <BookOpen size={32} className="text-slate-300 group-hover:text-white transition-colors" />
                  <ArrowRight size={24} className="text-slate-400 group-hover:text-white group-hover:translate-x-2 transition-all" />
                </div>
                <h2 className="text-3xl font-serif mb-3 text-white">
                  Lookbook <span className="italic">Pacifico</span>
                </h2>
                <p className="text-slate-400 text-sm leading-relaxed">
                  A curated collection of architectural residences and vacation properties.
                </p>
                <div className="mt-6 pt-6 border-t border-white/10">
                  <span className="text-[10px] uppercase tracking-[0.3em] text-slate-500 font-bold">
                    2 Properties Available
                  </span>
                </div>
              </div>
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500/0 to-purple-500/0 group-hover:from-blue-500/10 group-hover:to-purple-500/10 transition-all duration-500"></div>
            </Link>

            {/* Altamar Beach House Card */}
            <Link 
              to="/altamar/1"
              className="group relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg overflow-hidden hover:bg-white/10 transition-all duration-500 hover:scale-105 hover:shadow-2xl"
            >
              <div className="p-8">
                <div className="flex items-center justify-between mb-6">
                  <BookOpen size={32} className="text-slate-300 group-hover:text-white transition-colors" />
                  <ArrowRight size={24} className="text-slate-400 group-hover:text-white group-hover:translate-x-2 transition-all" />
                </div>
                <h2 className="text-3xl font-serif mb-3 text-white">
                  Casa <span className="italic">Altamar</span>
                </h2>
                <p className="text-slate-400 text-sm leading-relaxed">
                  Beachfront property at Playa el Amatal. Mobile-optimized for easy sharing.
                </p>
                <div className="mt-6 pt-6 border-t border-white/10">
                  <span className="text-[10px] uppercase tracking-[0.3em] text-slate-500 font-bold">
                    Mobile Share Page
                  </span>
                </div>
              </div>
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/0 to-blue-500/0 group-hover:from-cyan-500/10 group-hover:to-blue-500/10 transition-all duration-500"></div>
            </Link>

            <div className="relative bg-white/5 backdrop-blur-sm border border-white/10 border-dashed rounded-lg overflow-hidden opacity-50">
              <div className="p-8">
                <div className="flex items-center justify-between mb-6">
                  <BookOpen size={32} className="text-slate-500" />
                </div>
                <h2 className="text-3xl font-serif mb-3 text-slate-400">
                  Coming <span className="italic">Soon</span>
                </h2>
                <p className="text-slate-500 text-sm leading-relaxed">
                  More lookbooks will be added here.
                </p>
                <div className="mt-6 pt-6 border-t border-white/10">
                  <span className="text-[10px] uppercase tracking-[0.3em] text-slate-600 font-bold">
                    Stay Tuned
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-white/10 py-16 px-8 mt-20">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-slate-400 text-sm">
            &copy; 2026 mylookbook.online - Your digital storefront platform
          </p>
        </div>
      </footer>
    </div>
  );
}

// Made with Bob
